var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var streamKeys = [
    "symbol",
    "curPrice",
    "changePrice",
    "changePercentage",
];
var NewsResponseMappper = /** @class */ (function () {
    function NewsResponseMappper() {
    }
    NewsResponseMappper.prototype.formatResponse = function (streamRes, cb) {
        var _a;
        try {
            var ResData = JSON.parse(streamRes).response.data;
            if (((_a = ResData.custom_elements) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                var data = __assign(__assign({}, ResData), { customElements: ResData.custom_elements, timeText: ResData.date });
                cb(data);
            }
            else {
                var data = __assign(__assign({}, ResData), { timeText: ResData.date });
                cb(data);
            }
        }
        catch (error) { }
    };
    return NewsResponseMappper;
}());
export default NewsResponseMappper;
